export default function getEnv(name) {
  return window?.publicRuntimeConfig?.[name] || process.env[name];
}
